import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Section from "./pages/Section";
import Article from "./pages/Article";
import Search from "./pages/Search";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Contact from "./pages/Contact";
import StaticPage from "./pages/StaticPage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/section/:slug" element={<Section />} />
                <Route path="/article/:slug" element={<Article />} />
                <Route path="/search" element={<Search />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/about" element={<StaticPage page="about" />} />
                <Route path="/privacy" element={<StaticPage page="privacy" />} />
                <Route path="/terms" element={<StaticPage page="terms" />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<div className="max-w-3xl mx-auto py-24 text-center font-serif-display text-4xl text-[#081422]">404</div>} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
